import { render } from "./SelesaiMeeting.vue?vue&type=template&id=45dd655c"
import script from "./SelesaiMeeting.vue?vue&type=script&lang=js"
export * from "./SelesaiMeeting.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__